import React from 'react';
import { motion } from 'framer-motion';
import './Clients.css';

// Import client logos
import assetBase from '../images/Clients/asset base logo.PNG';
import bestOption from '../images/Clients/best option properties logo.jpg';
import cornelius from '../images/Clients/cornelius hope academy schools.jfif';
import paoz from '../images/Clients/paoz.png';
import voh from '../images/Clients/voh zimbabwe logo.PNG';

const Clients = () => {
    const clientLogos = [
        { src: assetBase, alt: "Asset Base" },
        { src: bestOption, alt: "Best Option Properties" },
        { src: cornelius, alt: "Cornelius Hope Academy" },
        { src: paoz, alt: "PAOZ" },
        { src: voh, alt: "VOH Zimbabwe" }
    ];

    // Duplicate logos for seamless infinite scroll
    const duplicatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

    return (
        <section className="clients-section">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="section-badge">Trusted By</span>
                    <h2 className="section-title">Our <span className="text-gradient">Clients</span></h2>
                    <p className="section-description">
                        Partnering with leading organizations to deliver exceptional digital solutions.
                    </p>
                </motion.div>

                <div className="logos-slider">
                    <div className="logos-track">
                        {duplicatedLogos.map((logo, index) => (
                            <div key={index} className="logo-item">
                                <img src={logo.src} alt={logo.alt} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Clients;
